import { InjectionToken, Signal } from '@angular/core';

export interface CarePlanCurrentUser {
  id: Signal<string | null>;
  displayName: Signal<string>;
}

export const CARE_PLAN_CURRENT_USER = new InjectionToken<CarePlanCurrentUser>(
  'CARE_PLAN_CURRENT_USER',
);
